module.exports = __webpack_public_path__ + "img/r-158.6ff5e96c.jpg";